<template>
  <div id="app">
    <router-view />
    <Loader :visible="loading" />
    <Footer />
  </div>
</template>

<script>
import Footer from "./components/Footer.vue";
import { mapState } from "vuex";
import Loader from "./components/Loader";
import httpClient from "./api/httpClient";

export default {
  name: "App",
  components: {
    Loader,
    Footer,
  },
  created() {
    window.addEventListener("beforeunload", function (event) {
      console.log("BEFORE UNLOAD");
    });
    window.addEventListener("unload", function (event) {
      event.returnValue = "Write something";
    });
    /*window.addEventListener("beforeunload", function (event) {
      event.returnValue = "Write something";
      this.$router.push("/login");
    });
    window.addEventListener("beforePageDestroyed", function (event) {
      event.returnValue = "Write something";
      this.$router.push("/login");
    });*/
  },
  methods: {
    beforePageDestroyed: function (event) {
      //alert("beforePageDestroyed");
    },
  },
  computed: {
    ...mapState("loader", ["loading"]),
  },
};
</script>

<style lang="scss">
@import "./scss/main.scss";
</style>
